if(typeof __WEBPACK_EXTERNAL_MODULE__19__ === 'undefined') {var e = new Error("Cannot find module 'crypto'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE__19__;